module.exports = __webpack_public_path__ + "static/media/fishes.c73eff0a.png";